import {Moment} from 'moment';
import {EarnedProductData} from '../../../../shared/types';
import genChartPlaceholderData from './genChartPlaceholderData';

const transformChartData = (
    productData: EarnedProductData[],
    period?: Date | string | number | Moment
): EarnedProductData[] => {
    const data = [];
    const placeholderData = genChartPlaceholderData(period);
    const tProductData = productData.reduce((prev, entry) => {
        prev[entry.date] = entry;
        return prev;
    }, {});

    for (const dateKey in placeholderData) {
        if (typeof dateKey === 'string') {
            data.push({...placeholderData[dateKey], ...tProductData[dateKey]});
        }
    }
    return data;
};

export default transformChartData;
